import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import '@/App.css';
import InitialInputScreen from './components/InitialInputScreen';
import UserOrganizedViewPage from './components/UserOrganizedViewPage';
import DecisionLogPage from './components/DecisionLogPage';
import AuthCallback from './components/AuthCallback';
import AdminDashboard from './pages/AdminDashboard';
import TestCasesList from './pages/TestCasesList';
import TestCaseViewer from './pages/TestCaseViewer';
import TestCaseComparison from './pages/TestCaseComparison';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
      }
    } catch (error) {
      console.log('Not authenticated');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="app-container flex flex-col min-h-screen">
      <BrowserRouter>
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<InitialInputScreen user={user} />} />
            <Route path="/decide/:decisionId/edit" element={<UserOrganizedViewPage user={user} setUser={setUser} mode="edit" />} />
            <Route path="/decide/:decisionId/view" element={<UserOrganizedViewPage user={user} setUser={setUser} mode="view" />} />
            <Route path="/decide/:decisionId" element={<UserOrganizedViewPage user={user} setUser={setUser} mode="edit" />} />
            <Route path="/decisions" element={<DecisionLogPage user={user} />} />
            <Route path="/auth/callback" element={<AuthCallback setUser={setUser} />} />
            <Route path="/admin/feedback-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/test-cases" element={<TestCasesList />} />
            <Route path="/admin/test-cases/:testId/compare" element={<TestCaseComparison />} />
            <Route path="/admin/test-cases/:testId" element={<TestCaseViewer />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </div>
        <Footer />
        <Toaster 
          position="top-center"
          toastOptions={{
            style: {
              background: 'white',
              color: '#1f2937',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
            },
            success: {
              style: {
                background: '#ccfbf1',
                color: '#0f766e',
                border: '1px solid #5eead4'
              }
            },
            error: {
              style: {
                background: '#fce7f3',
                color: '#9f1239',
                border: '1px solid #f9a8d4'
              }
            }
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
